import React from 'react';
import { SafeAreaView } from 'react-native';
import { NativeBaseProvider, View, Spinner, extendTheme, v33xTheme } from 'native-base';
import { colors, fontSizes, breakpoints } from '../../theme';
import Comments from '../content/platform/Comments';
const theme = extendTheme({
  v33xTheme,
  colors,
  fontSizes,
  breakpoints
});
const ContentItemCommentsPresentation = props => {
  return /*#__PURE__*/React.createElement(NativeBaseProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(SafeAreaView, null, !props.userAuthenticated ? /*#__PURE__*/React.createElement(View, {
    alignItems: 'center'
  }, /*#__PURE__*/React.createElement(Spinner, null)) : /*#__PURE__*/React.createElement(Comments, props)));
};
export default ContentItemCommentsPresentation;
//# sourceMappingURL=ContentItemCommentsPresentation.js.map